import { render, staticRenderFns } from "./RetailTable.vue?vue&type=template&id=33f1fd24&scoped=true"
import script from "./RetailTable.vue?vue&type=script&lang=js"
export * from "./RetailTable.vue?vue&type=script&lang=js"
import style0 from "./RetailTable.vue?vue&type=style&index=0&id=33f1fd24&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f1fd24",
  null
  
)

export default component.exports